import request from '@/http/request'
import { createCachedApi } from '@/utils/apiCache'

// 参考数据缓存 TTL：10 分钟
var REF_TTL = 10 * 60 * 1000

/**
 * 产品查询接口（用户相关，不缓存）
 */
export function getProductList(params){
    return request({
        url:'/system/product/list',
        method:'get',
        params,
    })
}

/**
 * 产品筛选类型接口（缓存）
 */
export var getProductFilterType = createCachedApi(function(params){
    return request({
        url:'/system/product/filterType',
        method:'get',
        params,
    })
}, REF_TTL)


/**
 * 家族系列筛选（依赖筛选参数，不缓存）
 */
export function getProductFilter(data){
    return request({
        url:'/system/categories/filter',
        method:'post',
        data:data
    })
}

/**
 * 产品分类查询接口（缓存）
 */
export var getProductType = createCachedApi(function(params){
    return request({
        url:'/system/categories/list',
        method:'get',
        params,
    })
}, REF_TTL)

/**
 * 查询首页轮播配置（缓存）
 */
export var getHomeBanner = createCachedApi(function(){
    return request({
        url:'/system/carousel/list',
        method:'get',
    })
}, REF_TTL)

/**
 * 查询首页公司轮播配置（缓存）
 */
export var getCompanyBanner = createCachedApi(function(){
    return request({
        url:'/system/companycarousel/list',
        method:'get',
    })
}, REF_TTL)

/**
 * 查询首页视频配置列表（缓存）
 */
export var listVideo = createCachedApi(function() {
    return request({
      url: '/system/video/list',
      method: 'get',
    })
}, REF_TTL)
